import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-operator-license',
  templateUrl: './operator-license.component.html',
  styleUrls: ['./operator-license.component.scss']
})
export class OperatorLicenseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
